/**
 * 动态路由
 */
import router from './router'
// 页面导航加载条
import NProgress from 'nprogress'
// 导航加载条样式
import 'nprogress/nprogress.css'
// 权限相关存储
import usePermissionStore from '@/store/modules/permission'
import { getToken, removeToken } from '@/utils/token'
import { initStore } from '@/utils/initStore'
// 标识当前路由是否已加载
export let loadRoutes = false
export const setLoadRoutesState = (waitRoute?: string) => {
    loadRoutes = true
    if (waitRoute) {
        router.replace(waitRoute)
    }
}

/**
 * 初始化路由守卫
 * @returns permissionStore
 */
export default function setupPermission() {
    return new Promise<void>((resolve, reject) => {
        try {
            // 路由加载效果
            NProgress.configure({ showSpinner: true })
            // 增加三方登陆
            const whiteList = ['/login', '/404']
            router.beforeEach(async to => {
                // 开启进度条
                NProgress.start()
                // 判断token是否存在
                if (getToken()) {
                    // 如果跳转的路径是登录页
                    if (to.path === '/login') {
                        await resetRouter()
                        return { path: '/' }
                    }
                    if (!loadRoutes) {
                        try {
                            await initRouter()
                            // 整页刷新后 MapCache 等内存持久化无法带回 avatar，需从接口拉一次用户信息（内含头像 ID + store 内 syncAvatarBlobUrl）
                            const { default: useUserStore } = await import('@/store/modules/user')
                            try {
                                await useUserStore().fetchUserInfo()
                            } catch {
                                /* 与接口错误拦截一致，不阻断动态路由挂载 */
                            }
                            setLoadRoutesState(to.fullPath)
                        } catch {
                            NProgress.done()
                            removeToken()
                            initStore()
                            await resetRouter()
                            return {
                                name: 'Login',
                                query: {
                                    redirect: to.fullPath
                                }
                            }
                        }
                    }
                } else {
                    await resetRouter()
                    // 不在免登录白名单，返回登陆页
                    if (!whiteList.includes(to.path)) {
                        ElMessage.closeAll()
                        // ElMessage.error('登录已失效，请重新登录')
                        return {
                            name: 'Login',
                            query: {
                                redirect: to.fullPath
                            }
                        }
                    }
                }
                NProgress.done()
            })
            router.afterEach(() => {
                NProgress.done()
            })
            resolve()
        } catch (error) {
            reject(error)
        }
    })
}
/**
 *  @description 初始化路由
 *  从store 中获取动态路由数据，并添加到路由中
 */
export const initRouter = async () => {
    try {
        const permissionStore = usePermissionStore()
        // 布局组件添加自动重定向
        const accessRoutes = await permissionStore.getStore('generateRoutes')()
        const firstPage = accessRoutes.find(route =>
            !route.meta?.hidden && !route.meta?.disabled && (route.component || route.redirect)
        )
        router.getRoutes().forEach(route => {
            if (route.name === 'Layout' && firstPage) {
                route.redirect = firstPage.path
            }
        })
        addRoutes(accessRoutes)
    } catch (error) {
        return Promise.reject(error)
    }
}
/**
 * @description 重置路由
 */
export const resetRouter = async () => {
    router.clearRoutes()
    const permissionStore = usePermissionStore()
    const staticRoutes = await permissionStore.getStore('staticRoutes')
    staticRoutes.forEach(route => {
        // 检查路由是否已存在，避免重复添加
        const existingRoute = router.hasRoute(route.name)
        if (!existingRoute) {
            router.addRoute(route)
        }
    })
}
/**
 * @description 添加路由
 * @param {Array} routes 路由列表
 * @param {string} parentName 父级路由名称
 */
const addRoutes = (routes, parentName = 'Layout') => {
    routes.forEach(route => {
        // 检查路由是否已存在，避免重复添加
        const existingRoute = router.hasRoute(route.name)
        if (!existingRoute) {
            router.addRoute(parentName, route)
        }
    })
}
